import { mapGetters } from 'vuex';

/**
 * 테이블 패딩 적용 mixin
 *
 * @param {Object} options
 * @param {string} options.refName - 대상 컨테이너 ref 이름 (예: 'mdRoot', 'htmlRoot')
 * @param {string} [options.selector='table td, table th'] - 셀 선택자
 * @param {string} [options.contentWatchProp] - 콘텐츠 변경 감지 computed 이름 (예: 'sanitizedMarkdown')
 */
export function createTablePaddingMixin({
  refName,
  selector = 'table td, table th',
  contentWatchProp
} = {}) {
  const mixin = {
    computed: {
      ...mapGetters('report_contents', ['table_vertical_padding', 'table_horizontal_padding']),
      tablePadding() {
        return `${this.table_vertical_padding}rem ${this.table_horizontal_padding}rem`;
      }
    },
    watch: {
      tablePadding() {
        this.$nextTick(() => this.applyTablePadding());
      }
    },
    mounted() {
      this.$nextTick(() => this.applyTablePadding());
    },
    methods: {
      applyTablePadding() {
        if (!this.$refs[refName]) return;
        const cells = this.$refs[refName].querySelectorAll(selector);
        cells.forEach(cell => {
          if (!cell.style.padding && !cell.getAttribute('style')?.includes('padding')) {
            cell.style.padding = this.tablePadding;
          }
        });
      }
    }
  };

  if (contentWatchProp) {
    mixin.watch[contentWatchProp] = function () {
      this.$nextTick(() => this.applyTablePadding());
    };
  }

  return mixin;
}
